import React, { useEffect, useState } from "react";
import s from "./wheel.module.css";
import {
  changeMapMode,
  changeRotationAngle,
} from "../../../services/reducers/map";
import { useAppDispatch } from "../../../hooks/useAppDispatch";

export default function Wheel({ is3D }: { is3D: boolean }) {
  const dispatch = useAppDispatch();
  const [angle, setAngle] = useState(0);
  const [center, setCenter] = useState({ x: 0, y: 0 });

  const handleMouseDown = (event: React.MouseEvent) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setCenter({ x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 });
  };

  const handleMouseMove = (event: MouseEvent) => {
    if (center.x !== 0 && center.y !== 0) {
      const deltaX = event.clientX - center.x;
      const deltaY = event.clientY - center.y;

      const newAngle = Math.atan2(deltaY, deltaX) * (180 / Math.PI);
      setAngle(newAngle);

      dispatch(changeRotationAngle(newAngle));
    }
  };

  const handleMouseUp = () => {
    setCenter({ x: 0, y: 0 });
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [center]);

  return (
    <div className={s.wheel}>
      <div className={s.threeDSwitcherButtonContainer}>
        <button
          className={`${s.threeDSwitcherButton}`}
          onClick={() => dispatch(changeMapMode())}
        >
          {is3D ? "2D" : "3D"}
        </button>
      </div>
      <div className={s.arrowsContainer}>
        <div
          className={s.arrowsInnerContainer}
          style={{ transform: `rotate(${angle}deg)` }}
          onMouseDown={handleMouseDown}
        >
          {["north", "east", "south", "west"].map((item: string) => (
            <button key={item} className={`${s.arrow} ${s[item]}`}></button>
          ))}
        </div>
      </div>
    </div>
  );
}
